export class Deferred {
    constructor() {
        this.innerPromise = new Promise((resolve, reject) => {
            this.resolveFunc = resolve;
            this.rejectFunc = reject;
        });
    }
    get promise() {
        return this.innerPromise;
    }
    resolve(value) {
        this.resolveFunc(value);
    }
    reject(reason) {
        this.rejectFunc(reason);
    }
}
//# sourceMappingURL=Deferred.js.map